"use strict";
import angular from "angular";

import sitzungsmodule from "dias/sitzungen/sitzungsmodule";

import preview from "./preview.component";

const modul = angular.module("standard_sitzungsmodule.niederschrift", [
  sitzungsmodule.name,
])

  .config(/*@ngInject*/SitzungsmodulRegistryProvider => {
    SitzungsmodulRegistryProvider.register("niederschrift", undefined, "modul-niederschrift-preview");
  })

  .component("modulNiederschriftPreview", preview)
;

export default modul;
